<section>

  @if (productSubsInfo()?.subscribeAndcustomizeBox) {
  <p>How often would you want to receive your Farmbox?</p>
  } @else {
  <p>When would you like to receive your subscription item(s)?</p>
  }

  <mat-form-field class="rounded-selector mb-3 d-flex" subscriptSizing="dynamic">
    <mat-label>Frequency </mat-label>
    <mat-select (selectionChange)="onChangeFrequency($event)" [value]="selectedFrequency?.id">
      @for(freq of frequencies(); track $index){
      <mat-option [value]="freq.id">{{ freq.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- @if (!productSubsInfo()?.subscribeAndcustomizeBox) { -->
  @if (!isTemporaryRouteChange()) {
  <mat-checkbox [checked]="true" class="mb-3" (change)="initiateSubscriptionImmediatly.set($event.checked)">
    Initiate my subscription immediately
  </mat-checkbox>
  }

  @if (initiateSubscriptionImmediatly()) {
  <app-empty-message [width100]="true" [mt0]="true"
    [message]="'Next Delivery: ' + deliveryZoneInfo()?.readeableDeliveryDate"></app-empty-message>
  } @else {

  @if (productSubsInfo()?.subscribeAndcustomizeBox) {
  <p>When do you like to receive your first Farmbox?</p>
  }

  <mat-form-field class="w-100 mb-3">
    <mat-label>Start subscription date</mat-label>
    <input matInput [min]="minDate()" [matDatepicker]="startSubscription"
      [matDatepickerFilter]="dateFilter" disabled (dateChange)="onDateChange($event)">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="startSubscription"></mat-datepicker-toggle>
    <mat-datepicker [yPosition]="'below'" #startSubscription disabled="false"></mat-datepicker>
  </mat-form-field>
  }

  @if (isTemporaryRouteChange() && productSubsInfo()?.subscribeAndcustomizeBox) {
  <app-empty-message [width100]="true" [mt0]="true" [displayIcon]="false" [isHtml]="true"
    [message]="temporaryRouteChangeCustomMessage()"></app-empty-message>
  }
  <!-- } -->

  <hr>

  <div class="card-footer p-0 mt-1 mt-auto">
    <div class="row">
      @if (productSubsInfo()?.subscribeAndcustomizeBox) {
      <div class="col">
        <button type="button" (click)="continue()"
          [disabled]="!selectedFrequency || (!this.initiateSubscriptionImmediatly() && !this.selectedDateSubscription)"
          class="btn btn-secondary d-flex gap-2 align-items-center">
          Subscribe & continue
        </button>
      </div>
      } @else {
      <div class="col">
        <button type="button" (click)="cancel()" class="btn btn-outline-secondary d-flex gap-2 align-items-center">
          Cancel
        </button>
      </div>
      <div class="col">
        <button type="button" (click)="subscribe($event)"
          [disabled]="!selectedFrequency || (!this.initiateSubscriptionImmediatly() && !this.selectedDateSubscription)"
          class="btn btn-secondary d-flex gap-2 align-items-center">
          Subscribe
        </button>
      </div>
      }
    </div>
  </div>

</section>